export default __webpack_public_path__ + "static/ink-v-4ab4317e3d59030fffef3ea51f635d72.jpg";